import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { type GroupDetails } from '../modal/group';

export const getAllGroupsAPI = async () => {
  const response = await baseAPI.get<Array<GroupDetails>>(`/custom-form/group`);
  return response.data;
};

export const useGetAllGroups = () => {
  return useQuery({
    queryKey: [KEYS.GROUPS],
    queryFn: () => getAllGroupsAPI(),
  });
};
